module.exports = __webpack_public_path__ + "static/img/东芝模块.f4f224f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/东芝模块.png
// module id = Q9oP
// module chunks = 1